import { type MetaFunction } from '@remix-run/react'
import { Button } from '#app/components/ui/button.tsx'
import {
	DrawerTitle,
	DrawerDescription,
	DrawerClose,
} from '#app/components/ui/drawer.tsx'
import { type loader as notesLoader } from './vandaag.tsx'

export default function NotesIndexRoute() {
	return (
		<div className="py-4">
			<DrawerTitle className="flex items-start">
				Je lichtje is aangestoken
			</DrawerTitle>
			<DrawerDescription className="mb-2 mt-4 flex items-start">
				Je lichtje wordt toegevoegd en is voor de komende 24 uur door Poelie te
				zien. Je kunt dit venster sluiten en je lichtje bekijken in de kring van
				licht.
			</DrawerDescription>
			<DrawerClose className="absolute bottom-3 left-3 right-3 mt-4 flex w-full flex-1">
				<Button className="flex w-full flex-1">Sluiten</Button>
			</DrawerClose>
		</div>
	)
}

export const meta: MetaFunction<
	null,
	{ 'routes/marketing+/vandaag': typeof notesLoader }
> = ({ matches }) => {
	const notesMatch = matches.find((m) => m.id === 'routes/marketing+/vandaag')
	const totalNotes = notesMatch?.data?.allNotes.length ?? 0
	const notesText = totalNotes === 1 ? 'note' : 'notes'

	return [
		{ title: `Alle lichtjes van vandaag | Kring van Licht` },
		{
			name: 'description',
			content: `Bekijk alle ${totalNotes} ${notesText} brandende lichtjes op Kring van Licht`,
		},
	]
}
